export class UpdateProjectAction {
  static readonly type = '[Project] Update Project';

  constructor(public project) {}
}
